<script>
  import cloneDeep from "lodash/cloneDeep";
  import { Modal } from "svelte-utilities";
  import Dropzone from "#lib/dropzone/Dropzone.svelte";
  import SidebarSection from "./SidebarSection.svelte";
  import TextInput from "./TextInput.svelte";
  import DocumentThumbnail from "#lib/DocumentThumbnailMini.svelte";
  import UploadIcon from "@local/assets/icons/upload.svg";
  import ButtonInput from "./ButtonInput.svelte";
  import ShareIcon from "@local/assets/icons/share.svg";
  import VideoIcon from "@local/assets/icons/video.svg";
  import TableIcon from "@local/assets/icons/table.svg";
  import { api } from "#src/api";

  export let document;
  export let group;
  export let disabled = false;

  let thumbnailModal;
  let thumbnailDropzone;

  const extensions = {
    "image/jpeg": "jpg",
    "image/png": "png",
  };

  function toggleThumbnailModal() {
    thumbnailModal.open();
  }

  function updateDoc(prop, value) {
    const id = document.id;
    if (typeof id === "string") {
      group.updateDocument(id, { [prop]: value });
    }
  }

  async function uploadThumbnail(evt) {
    const { file, data } = evt.detail;
    const id = document.id;

    const uuid = crypto.randomUUID();
    const extension = extensions[file.type] || "jpg";
    const thumbName = `${id}/${uuid}-thumbnail.${extension}`;

    const stored = await api.storage.from("documents").upload(thumbName, data, {
      contentType: file.type,
    });

    if (stored.error) {
      console.error("Error uploading thumbnail:", stored.error);
      thumbnailDropzone.stopLoading();
      thumbnailModal.close();
      return;
    }

    const thumbnail = {
      bucket: "documents",
      path: stored.data.path,
      type: "image",
      name: document.name,
    };

    const ddata = cloneDeep(document.data);
    ddata.thumbnail = thumbnail;
    group.updateDocument(id, { data: ddata });
    thumbnailDropzone.stopLoading();
    thumbnailModal.close();
  }

  function visit() {
    window.open(document.data.url, "_blank");
  }
</script>

<SidebarSection>
  {#if document?.data.thumbnail}
    {#key document.data.thumbnail.path}
      <div class="thumbnail-container">
        <div class="relative aspect-square max-h-full max-w-full overflow-hidden border border-gray-300">
          <DocumentThumbnail doc={document} />
        </div>
        <div class="absolute top-0 left-0 p-2">
          {#if document?.data.doctype === "video"}
            <VideoIcon />
          {:else if document?.data.doctype === "spreadsheet"}
            <TableIcon />
          {:else}
            <ShareIcon />
          {/if}
        </div>
        <button class="absolute bottom-0 right-0 p-2" on:click={toggleThumbnailModal}>
          <UploadIcon />
        </button>
      </div>
    {/key}
  {/if}
  <TextInput
    label="Name"
    {disabled}
    labelWidth="5rem"
    value={document.name}
    on:input={(e) => updateDoc("name", e.detail.value)} />
  <ButtonInput
    label="Visit Link"
    labelWidth="5rem"
    value={null}
    buttons={[{ component: ShareIcon, label: "Visit Link", value: "link" }]}
    on:input={visit} />
</SidebarSection>

<Modal bind:this={thumbnailModal} closeable>
  <div slot="title">Upload</div>
  <div slot="content" class="space-y-2">
    <Dropzone on:drop={uploadThumbnail} bind:this={thumbnailDropzone} accept=".png,.jpeg,.jpg" />
  </div>
</Modal>

<style lang="scss">
  .thumbnail-container {
    @apply h-36 py-2 relative overflow-hidden flex items-center justify-center;

    button {
      visibility: hidden;
    }

    &:hover {
      button {
        visibility: visible;
      }
    }
  }
</style>
